import { render, staticRenderFns } from "./NavigationMini.vue?vue&type=template&id=028389a2&scoped=true&"
import script from "./NavigationMini.vue?vue&type=script&lang=js&"
export * from "./NavigationMini.vue?vue&type=script&lang=js&"
import style0 from "./NavigationMini.vue?vue&type=style&index=0&id=028389a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028389a2",
  null
  
)

export default component.exports